import { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Layout, Menu, Button, Typography, Space, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import {
  DashboardOutlined,
  PictureOutlined,
  VideoCameraOutlined,
  PlaySquareOutlined,
  CustomerServiceOutlined,
  SoundOutlined,
  KeyOutlined,
  LogoutOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/branding/logo.png';
import './layout.css';

const { Header, Sider, Content } = Layout;

const MEDIA_KEY = 'media';
const AUDIO_KEY = 'audio';

const menuItems: MenuProps['items'] = [
  { key: '/', icon: <DashboardOutlined />, label: '总览' },
  {
    key: MEDIA_KEY,
    icon: <PlaySquareOutlined />,
    label: '媒体',
    children: [
      { key: '/images', icon: <PictureOutlined />, label: '图片' },
      { key: '/videos', icon: <VideoCameraOutlined />, label: '视频' },
    ],
  },
  {
    key: AUDIO_KEY,
    icon: <CustomerServiceOutlined />,
    label: '音频',
    children: [
      { key: '/bgm', icon: <CustomerServiceOutlined />, label: '音乐' },
      { key: '/sfx', icon: <SoundOutlined />, label: '音效' },
    ],
  },
  { key: '/clients', icon: <KeyOutlined />, label: '凭证管理' },
];

export default function MainLayout() {
  const nav = useNavigate();
  const loc = useLocation();
  const { username, logout } = useAuth();
  const selected = loc.pathname === '/' ? '/' : `/${loc.pathname.split('/')[1]}`;
  const [openKeys, setOpenKeys] = useState<string[]>([MEDIA_KEY, AUDIO_KEY]);

  return (
    <Layout className="shell">
      <Sider width={232} className="shell-sider" breakpoint="lg" collapsedWidth={72}>
        <div className="brand" onClick={() => nav('/')}>
          <img src={logo} alt="MOCUT" className="brand-logo" />
          <div>
            <div className="brand-name">MOCUT</div>
            <div className="brand-sub">Assets Console</div>
          </div>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selected]}
          openKeys={openKeys}
          onOpenChange={setOpenKeys}
          onClick={({ key }) => {
            if (key.startsWith('/')) nav(key);
          }}
          items={menuItems}
        />
      </Sider>
      <Layout>
        <Header className="shell-header">
          <Typography.Text className="header-hint">专业素材资源中枢</Typography.Text>
          <Dropdown
            menu={{
              items: [
                {
                  key: 'logout',
                  icon: <LogoutOutlined />,
                  label: '退出登录',
                  onClick: () => {
                    logout();
                    nav('/login');
                  },
                },
              ],
            }}
          >
            <Button type="text" className="user-btn" icon={<UserOutlined />}>
              <Space>{username || 'admin'}</Space>
            </Button>
          </Dropdown>
        </Header>
        <Content className="shell-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
